import React from 'react';

const IconCheck: React.FC<{className?: string}> =() => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 18 18">
            <path style={{fill: 'var(--primary-color)'}} fillRule="evenodd" d="M9 18c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9z" clipRule="evenodd"/>
            <path fill="#fff" d="M6.648 8.382c-.421-.358-1.052-.307-1.41.114-.358.421-.306 1.052.114 1.41l2.184 1.856c.404.343 1.005.312 1.371-.072l3.816-4c.382-.4.367-1.032-.033-1.414-.4-.38-1.032-.366-1.413.034L8.111 9.627 6.648 8.382z"/>
        </svg>
    );
}

export default IconCheck;
